module.exports = __webpack_public_path__ + "static/img/4.de7eb2e4.png";